import Pagination from './Pagination'

export { PaginationProps } from './Pagination'
export default Pagination



// WEBPACK FOOTER //
// ./components/pagination/index.js